import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { createNotificationIcon } from './NotificationIcon';
import { NOTIFICATION_ICON_BASE_CLASSNAME } from './Constants';
createComponents(".".concat(NOTIFICATION_ICON_BASE_CLASSNAME), createNotificationIcon, NO_PATTERN_BUSINESS_LOGIC);
